<!-- @format -->

<template>
  <transition name="el-fade-in" mode="out-in">
    <HolaconLottie v-if="createLoading == 'created'" class="w-100" key="create-loading" />
    <el-row v-else key="create-content" class="w-100">
      <div class="attendee-details">
        <div class="attendee-header">
          <div class="attendee-header-wrapper">
            <div class="attendee-header-wrapper-left">
              <div class="attendee-no">
                <span># {{ form.participantNO }}</span>
              </div>
              <div class="attendee-name">
                <span>
                  <b>{{ form.firstName }}</b>
                  {{ form.lastName }}
                </span>
              </div>
              <div class="attendee-tag" v-if="$store.state.tags.items.find(x => x.id == form.tagID)">
                <span>
                  <i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == form.tagID).color }"></i>
                  {{ $store.state.tags.items.find(x => x.id == form.tagID).title }}
                </span>
              </div>
              <div class="attendee-tag" v-if="$store.state.tags.items.find(x => x.id == form.tagID)">
                <span v-for="(tagItem, index) in form.subTagIds" :key="tagItem + '-subtagitem-' + index">
                  <i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == tagItem).color }"></i>
                  {{ $store.state.tags.items.find(x => x.id == tagItem).title }}
                </span>
              </div>
              <div class="attendee-email" v-if="form.registrationInputs.find(x => x.type == 1) != null && form.registrationInputs.find(x => x.type == 1).answer != null">
                <a href="mailto:">
                  <i class="fas fa-envelope"></i>
                  {{ form.registrationInputs.find(x => x.type == 1).answer }}
                </a>
              </div>
              <div class="attendee-phone" v-if="form.registrationInputs.find(x => x.type == 2) != null && form.registrationInputs.find(x => x.type == 2).answer != null">
                <a href="tel:">
                  <i class="fas fa-phone"></i>
                  {{ form.registrationInputs.find(x => x.type == 2).answer }}
                </a>
              </div>
            </div>
            <div class="attendee-header-wrapper-right">
              <div class="attendee-profile-pic" :style="{ backgroundImage: 'url(' + form.imagePublic + ')' }">
                <!-- <img :src="$imageus + form.imagePublic+ '&width=500&height=500'" class="img-fluid" /> -->
              </div>
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.update") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="takePictureModal = true">{{ $t("participantManagament.registrationSearch.detailsParticipant.useCam") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="addProfilePicture">{{ $t("participantManagament.registrationSearch.detailsParticipant.updatePhoto") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="attendee-header-actions">
            <div class="attendee-header-actions-left">
              <el-dropdown>
                <el-button size="medium">
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.submission") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="sendParticipantVoucher">{{ $t("participantManagament.registrationSearch.detailsParticipant.sendVoucher") }}</el-dropdown-item>
                  <!-- <el-dropdown-item>E-Posta gönder</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="medium" type="primary" @click="updateParticipantDialog = !updateParticipantDialog" icon="fas fa-pen">{{ $t("participantManagament.registrationSearch.detailsParticipant.edit") }}</el-button>
            </div>
            <div class="attendee-header-actions-right">
              <el-dropdown :disabled="loading == 'actionsButton'">
                <el-button size="medium" :loading="loading == 'actionsButton'">
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.operations") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="printCardDialog = !printCardDialog">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCard") }} ({{ form.cardPrints.length }})</el-dropdown-item>
                  <el-dropdown-item @click.native="checkIn">{{ $t("participantManagament.registrationSearch.detailsParticipant.checkin") }} ({{ form.checkIns.length }})</el-dropdown-item>
                  <el-dropdown-item divided @click.native="openProxyDialog">{{ $t("participantManagament.registrationSearch.detailsParticipant.addProxy") }}</el-dropdown-item>

                  <el-dropdown-item @click.native="blockParticipant">{{ form.isBlocked ? $t("participantManagament.registrationSearch.detailsParticipant.unblock") : $t("participantManagament.registrationSearch.detailsParticipant.block") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="updateParticipantDialog = !updateParticipantDialog" divided>{{ $t("participantManagament.registrationSearch.detailsParticipant.editInformation") }}</el-dropdown-item>
                  <!-- <el-dropdown-item>Katılımcı kartını aç</el-dropdown-item> -->

                  <el-dropdown-item @click.native="participantDelete">{{ $t("participantManagament.registrationSearch.detailsParticipant.deleteRegistration") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.paymentInfos.some(x => x.paymentStatus == 0)">
          <div class="attendee-info payment-confirmation-awaiting">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fa fa-exclamation-circle"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.paymentPendingConfirmation") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.paymentPendingConfirmationMsg") }}</span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="payment-confirmation-awaiting-item" v-for="payment in form.paymentInfos.filter(x => x.paymentStatus == 0)" :key="'awaiting-payment-' + payment.id">
                <span @click="openPayment(payment)">#{{ payment.paymentID }}</span>
                <span>{{ payment.paidPrice > 0 ? $currency.format(payment.paidPrice, { code: getEnumsDisplay("Currency", payment.currency) }) : $t("participantManagament.registrationSearch.detailsParticipant.free") }}</span>
                <el-button size="small" type="danger" icon="el-icon-check" :loading="loading == 'ApprovePayment-' + payment.paymentID" @click="approvePayment(payment.paymentID, 1)" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.confirm") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.proxyParticipant != null">
          <div class="attendee-info proxy-added">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-user-friends"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.proxyAppointed") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.proxyAppointedMsg") }}</span>
              </div>
            </div>

            <div class="attendee-info-content">
              <div class="proxy-added-item">
                <i class="fas fa-level-up-alt"></i>

                <ParticipantMini :data="prepareParticipantMini(form.proxyParticipant.participant)" @click.native="openParticipant(form.proxyParticipant.participant.id)" :type="1" />
              </div>
              <div class="proxy-added-item">
                <i class="fas fa-level-up-alt"></i>
                <b>{{ form.proxyParticipant.owner.firstName + " " + form.proxyParticipant.owner.lastName[0] }}. {{ $t("participantManagament.registrationSearch.detailsParticipant.assignedBy") }} {{ $moment(form.proxyParticipant.createDate).format("DD MMMM YYYY, HH:mm") }}</b>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.dayRestrictions.length > 0 && !form.dayRestrictions.some(x => new Date(x).toISOString() == dateNow)">
          <div class="attendee-info event-day-limit">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-calendar-times"></i>
              </div>
              <div class="attendee-info-text">
                <span></span>
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.dayRestriction") }}</b>
                </span>
                <span>
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.dayRestrictionMsg") }}
                </span>
              </div>
            </div>
            <div class="attendee-info-content">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.participationDays") }}</span>
              <div class="event-day-limit-item">
                <span v-for="(day, dayIndex) in form.dayRestrictions" :key="'day-restrictions-' + dayIndex">
                  <i class="fas fa-calendar-check"></i>
                  {{ $moment(day).format("DD MMMM YYYY, dddd") }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.isBlocked">
          <div class="attendee-info attendee-blocked">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-ban"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.participantBlocked") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.participantBlockedMsg") }}</span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="attendee-blocked-item" v-if="form.blockInformation != null">
                <i class="fas fa-level-up-alt"></i>
                <span>
                  <b>{{ form.blockInformation.owner.firstName + " " + form.blockInformation.owner.lastName[0] }}</b>
                  - {{ $moment(form.blockInformation.blockedAt).format("DD MMMM YYYY, HH:mm") }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="false">
          <div class="attendee-info payment-awaiting">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-shopping-basket"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.paymentPending") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.paymentPendingMsg") }}</span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="payment-awaiting-item">
                <span>Registration</span>
                <span>Premium paket</span>
                <span>90,00 TRY</span>
              </div>
              <div class="payment-awaiting-item">
                <span>Accompany</span>
                <span>1 Ad Soyad</span>
                <span>90,00 TRY</span>
              </div>
              <div class="payment-awaiting-item">
                <span>Additional Service</span>
                <span>Konaklama 1</span>
                <span>90,00 TRY</span>
              </div>
              <div class="payment-awaiting-item">
                <span>Additional Service</span>
                <span>Alt etkinlik 1</span>
                <span>90,00 TRY</span>
              </div>
              <div class="attendee-info-actions">
                <el-button type="danger" size="medium" icon="el-icon-s-finance" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.addPayment") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.accompayingPersons.some(x => x.status == 0) || form.additionalServices.some(x => x.status == 0)">
          <div class="attendee-info addservices-awaiting-confirmation">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.watingForApporval") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.watingForApporvalMsg") }}</span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="addservices-awaiting-confirmation-item" v-for="accom in form.accompayingPersons.filter(x => x.status == 0)" :key="accom.id">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.accompany") }}</b>
                  {{ accom.questions.find(x => x.type == 1000).answer }} {{ accom.questions.find(x => x.type == 10001).answer }}
                </span>
                <span class="price">{{ accom.price > 0 ? $currency.format(accom.price, { code: getEnumsDisplay("Currency", accom.currency) }) : $t("participantManagament.registrationSearch.detailsParticipant.free") }}</span>
                <el-button type="warning" size="small" icon="el-icon-check" :loading="loading == 'approveAccom-' + accom.id" @click="approveAccom(accom.id, 2)" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.confirm") }}</el-button>
              </div>

              <div class="addservices-awaiting-confirmation-item" v-for="service in form.additionalServices.filter(x => x.status == 0)" :key="service.id">
                <span v-if="service.additionalService != null">
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.additionalServices") }}</b>
                  {{ service.additionalService.title }}
                </span>
                <span class="price">{{ service.price > 0 ? $currency.format(service.price, { code: getEnumsDisplay("Currency", service.currency) }) : $t("participantManagament.registrationSearch.detailsParticipant.free") }}</span>
                <el-button type="warning" size="small" icon="el-icon-check" :loading="loading == 'approveService-' + service.id" @click="approveService(service.id, 2)" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.confirm") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.paymentInfos.some(x => x.paymentStatus == 2) && !form.paymentInfos.some(x => x.paymentStatus != 2)">
          <div class="attendee-info payment-rejected">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-times-circle"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.paymentsDeclined") }}</b>
                </span>
                <span>
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.paymentsDeclinedMsg") }}
                </span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="payment-rejected-item" v-for="payment in form.paymentInfos" :key="payment.id">
                <span>#{{ payment.paymentID }}</span>
                <span>{{ payment.paidPrice > 0 ? $currency.format(payment.paidPrice, { code: getEnumsDisplay("Currency", payment.currency) }) : $t("participantManagament.registrationSearch.detailsParticipant.free") }}</span>
                <el-button size="small" disabled round>{{ $t("participantManagament.registrationSearch.detailsParticipant.declined") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="form.subEventRegistrations.some(x => x.status == 0)">
          <div class="attendee-info subevents-awaiting-confirmation">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-link"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.subeventRegistration") }}</b>
                </span>
                <span>
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.subeventRegistrationMsg") }}
                </span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="subevents-awaiting-confirmation-item" v-for="subEvent in form.subEventRegistrations.filter(x => x.status == 0)" :key="subEvent.id">
                <span>{{ subEvent.subEvent.title }}</span>
                <el-button type="warning" size="small" icon="el-icon-check" :loading="loading == 'approveSubEvent-' + subEvent.id" @click="approveSubEvent(subEvent.id)" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.confirm") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="attendee-informations" v-if="false">
          <div class="attendee-info abstract-waiting">
            <div class="attendee-info-wrapper">
              <div class="attendee-info-icon">
                <i class="fas fa-pen-fancy"></i>
              </div>
              <div class="attendee-info-text">
                <span>
                  <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.waitingAbstractApproval") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.waitingAbstractApprovalMsg") }}</span>
              </div>
            </div>
            <div class="attendee-info-content">
              <div class="abstract-waiting-item">
                <span>#1234567</span>
                <span>Abstract isim kısmı</span>
                <el-button size="small" icon="fas fa-search" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.review") }}</el-button>
              </div>
              <div class="abstract-waiting-item">
                <span>#1234567</span>
                <span>Abstract isim kısmı</span>
                <el-button size="small" icon="fas fa-search" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.review") }}</el-button>
              </div>
              <div class="abstract-waiting-item">
                <span>#1234567</span>
                <span>Abstract isim kısmı</span>
                <el-button size="small" icon="fas fa-search" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.review") }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="activation-code">
          <div class="activation-code-wrapper">
            <div class="activation-code-icon">
              <i class="fas fa-key"></i>
            </div>
            <div class="activation-code-text">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.activationCode") }}</span>
              <span>
                <b>
                  {{ form.activation.activationCode }}
                  <el-tooltip class="item" effect="dark" :content="$t('event.buttons.copy')" placement="top"><i class="fas fa-copy" v-clipboard:success="copySuccess" :key="form.activation.activationCode" v-clipboard:copy="form.activation.activationCode"></i></el-tooltip>
                </b>
              </span>
              <span class="text-success" v-if="form.activation.activationDate">{{ $t("participantManagament.registrationSearch.detailsParticipant.activeDate", [$moment(form.activation.activationDate).format("DD MMMM YYYY, HH:mm")]) }}</span>
              <span class="text-danger" v-else>{{ $t("participantManagament.registrationSearch.detailsParticipant.activationNotUse") }}</span>
            </div>
          </div>
          <div class="activation-code-refresh">
            <el-tooltip class="item" effect="dark" :content="$t('buttonGeneral.refresh')" placement="top">
              <el-popconfirm icon="el-icon-info" :title="$t('participantManagament.registrationSearch.detailsParticipant.activationCodeSure')" :key="form.activation.activationCode" @confirm="refreshActivationCode" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.cancelBtn')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.yesRefreshBtn')">
                <el-button slot="reference" size="small" circle>
                  <i class="fas fa-sync fa-spin" v-if="loading == 'refreshActivationCode'"></i>
                  <i v-else class="fas fa-redo"></i>
                </el-button>
              </el-popconfirm>
            </el-tooltip>
          </div>
        </div>

        <div class="attendee-inner-details">
          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="attendeeDock = !attendeeDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-id-badge"></i>
                    </div>
                    <div class="section-head">
                      <label>{{ $t("participantManagament.registrationSearch.detailsParticipant.participantInformation") }}</label>
                      <i class="fa fa-angle-up" :class="attendeeDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="attendeeDock">
                    <div class="attendee-registration-section" v-if="attendeeDock">
                      <div class="question-list">
                        <template v-for="(question, questionIndex) in form.registrationInputs">
                          <div class="question-item" v-if="getQuestionOne(question) != null" :key="question.id + '_question_' + questionIndex">
                            <div class="question-title">{{ getQuestionOne(question).title }}</div>
                            <QuestionItem :question="getQuestionOne(question)" :registrationForm="registrationForm" />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="registrationDock = !registrationDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-pen-alt"></i>
                    </div>
                    <div class="section-head">
                      <label>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInformation") }}</label>
                      <i class="fa fa-angle-up" :class="registrationDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="registrationDock">
                    <RegistrationInfo v-if="registrationDock" :registerForm="registrationForm" :participant="form" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="subeventDock = !subeventDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-link"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.subEvent") }}
                        <span v-if="form.subEventRegistrations.length > 0">{{ form.subEventRegistrations.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="subeventDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="subeventDock" :key="refreshKey">
                    <AttendeeSubEventRegistration :data="form.subEventRegistrations" @refresh="refreshParticipant" v-if="subeventDock" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="productDock = !productDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-ticket-alt"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.additionalProduct") }}
                        <span v-if="form.additionalProductRegistrations.length > 0">{{ form.additionalProductRegistrations.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="productDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="productDock" :key="refreshKey">
                    <AttendeeProductRegistration :data="form.additionalProductRegistrations" @refresh="refreshParticipant" v-if="productDock" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="accompDock = !accompDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-user-friends"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.accompany") }}
                        <span v-if="form.accompayingPersons.length > 0">{{ form.accompayingPersons.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="accompDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="accompDock">
                    <AttendeeAccom v-if="accompDock" :accoms="form.accompayingPersons" :participant="form" @refresh="refreshParticipant" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="servicesDock = !servicesDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-briefcase"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.additionalServices") }}
                        <span v-if="form.additionalServices.length > 0">{{ form.additionalServices.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="servicesDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="servicesDock" :key="refreshKey">
                    <AttendeeServices v-if="servicesDock" :services="form.additionalServices" :participant="form" :additionalServices="registrationForm.additionalServices" @refresh="refreshParticipant" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row> -->

          <el-row v-if="false">
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="abstractsDock = !abstractsDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-pen-fancy"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.notices") }}
                        <span>1</span>
                      </label>
                      <i class="fa fa-angle-up" :class="abstractsDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action">
                    <el-button type="primary" size="mini" icon="fas fa-plus" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.add") }}</el-button>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="abstractsDock">
                    <AttendeeAbstract v-if="abstractsDock" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="false">
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="awaitingpaymentsDock = !awaitingpaymentsDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-shopping-basket"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.pendingPayments") }}
                        <span>1</span>
                      </label>
                      <i class="fa fa-angle-up" :class="awaitingpaymentsDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action">
                    <el-button type="danger" size="mini" icon="el-icon-s-finance" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.addPayment") }}</el-button>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="awaitingpaymentsDock">
                    <AttendeeAwaitingPayments v-if="awaitingpaymentsDock" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="paymentsDock = !paymentsDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-wallet"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.payments") }}
                        <span v-if="form.paymentInfos.length > 0">{{ form.paymentInfos.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="paymentsDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="paymentsDock">
                    <AttendeePayments v-if="paymentsDock" :paymentInfos="form.paymentInfos" :participant="form" @refresh="refreshParticipant" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="proccDock = !proccDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-history"></i>
                    </div>
                    <div class="section-head">
                      <label>{{ $t("participantManagament.registrationSearch.detailsParticipant.actions") }}</label>
                      <i class="fa fa-angle-up" :class="proccDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action"></div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="proccDock">
                    <AttendeeActions v-if="proccDock" :participant="form" :certschemes="certificateSchemes" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="custom-section-container mini">
                <div class="section-header" @click="notesDock = !notesDock">
                  <div class="section-title">
                    <div class="section-icon">
                      <i class="fas fa-clipboard"></i>
                    </div>
                    <div class="section-head">
                      <label>
                        {{ $t("participantManagament.registrationSearch.detailsParticipant.notes") }}
                        <span v-if="form.notes.length > 0">{{ form.notes.length }}</span>
                      </label>
                      <i class="fa fa-angle-up" :class="notesDock ? 'up' : ''"></i>
                    </div>
                  </div>
                  <div class="section-action">
                    <el-button type="primary" size="mini" icon="fas fa-plus" @click.stop="addNoteModal = !addNoteModal" round>{{ $t("participantManagament.registrationSearch.detailsParticipant.add") }}</el-button>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="notesDock">
                    <AttendeeNotes :notes="form.notes" v-if="notesDock" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <input type="file" @change="uploadFile" style="display: none" ref="file" />
      <el-dialog :close-on-click-modal="false" :visible.sync="printCardDialog" :title="$t('participantManagament.registrationSearch.detailsParticipant.cardPrint')" center append-to-body class="medium">
        <PrintCard v-if="printCardDialog" @refresh="refreshParticipant" @closeDialog="printCardDialog = false" :participantId="form.id" />
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="addNoteModal" :title="$t('participantManagament.registrationSearch.detailsParticipant.addNote')" class="medium" center append-to-body destroy-on-close>
        <AddParticipantNote v-if="addNoteModal" @closeDialog="addNoteModal = false" @refresh="refreshParticipant" :participantId="form.id" />
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="takePictureModal" :title="$t('participantManagament.registrationSearch.detailsParticipant.takePhoto')" class="medium" center append-to-body destroy-on-close>
        <AddPictureCamera v-if="takePictureModal" @closeDialog="takePictureModal = false" @setImage="setParticipantImage" />
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="updateParticipantDialog" :title="$t('participantManagament.registrationSearch.detailsParticipant.editParticipant')" class="large" append-to-body center destroy-on-close>
        <AddUpdateParticipant v-if="updateParticipantDialog" :id="form.id" @closeDialog="updateParticipantDialog = false" @refresh="refreshParticipant" />
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="addProxyDialog" class="medium" append-to-body center destroy-on-close :title="$t('participantManagament.registrationSearch.detailsParticipant.addProxyParticipant')">
        <AddProxy :participantId="form.id" :registrationForm="registrationForm" :registrationFormId="form.registrationFormId" v-if="addProxyDialog" @refresh="refreshParticipant" @closeDialog="addProxyDialog = false" />
      </el-dialog>
    </el-row>
  </transition>
</template>

<script>
import AddProxy from "./ParticipantDetails/AddProxy.vue";
import PrintCard from "./ParticipantDetails/PrintCard.vue";
import AddParticipantNote from "./ParticipantDetails/AddParticipantNote.vue";
import AddUpdateParticipant from "./AddUpdateParticipant.vue";
import RegistrationInfo from "./ParticipantDetails/RegistrationInfo.vue";
import AttendeeSubEventRegistration from "./ParticipantDetails/AttendeeSubEventRegistration.vue";
import AttendeeProductRegistration from "./ParticipantDetails/AttendeeProductRegistration.vue";
import AttendeeAccom from "./ParticipantDetails/AttendeeAccom.vue";
import AttendeeServices from "./ParticipantDetails/AttendeeServices.vue";
import AttendeeAbstract from "./ParticipantDetails/AttendeeAbstract.vue";
import AttendeeAwaitingPayments from "./ParticipantDetails/AttendeeAwaitingPayments.vue";
import AttendeePayments from "./ParticipantDetails/AttendeePayments.vue";
import AttendeeActions from "./ParticipantDetails/AttendeeActions.vue";
import AttendeeNotes from "./ParticipantDetails/AttendeeNotes.vue";
import QuestionItem from "../register-form/Inputs/QuestionItem.vue";
import AddPictureCamera from "@/components/participants/dialog/AddPictureCamera.vue";
import axios from "axios";
export default {
  components: {
    AddProxy,
    AddUpdateParticipant,
    AddParticipantNote,
    RegistrationInfo,
    AttendeeSubEventRegistration,
    AttendeeAccom,
    AttendeeServices,
    AttendeeAbstract,
    AttendeeAwaitingPayments,
    AttendeeProductRegistration,
    AttendeePayments,
    AttendeeActions,
    AttendeeNotes,
    QuestionItem,
    PrintCard,
    AddPictureCamera
  },
  props: ["id"],
  data() {
    return {
      certificateSchemes: [],
      addNoteModal: false,
      refreshKey: +new Date(),
      addProxyDialog: false,
      updateParticipantDialog: false,
      attendeeDock: true,
      registrationDock: true,
      subeventDock: false,
      productDock: false,
      accompDock: false,
      servicesDock: false,
      abstractsDock: false,
      awaitingpaymentsDock: false,
      paymentsDock: false,
      proccDock: false,
      notesDock: false,
      takePictureModal: false,
      form: null,
      showAccomDetails: false,
      activeDetails: ["1"],
      createLoading: false,
      printCardDialog: false,
      axios,
      timeout: null,
      loading: false,
      onsiteUser: null,
      allQuestions: [],
      registrationForm: null
    };
  },
  methods: {
    openParticipant(id) {
      this.$emit("closeDialog");
      this.openParticipantDetail(id);
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    openProxyDialog() {
      if (true) {
        this.addProxyDialog = !this.addProxyDialog;
      } else {
        this.openUpgradeDialog();
      }
    },
    openPayment(payment) {
      this.openPaymentDetail(payment, this.form);
    },
    async approvePayment(id, status) {
      this.loading = "ApprovePayment-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          paymentID: id,
          status: status,
          cancellationReason: null
        };
        var res = await this.$store.dispatch("changeParticipantStatus", payload);
        if (!res.data.alert.hasError) {
          await this.refreshParticipant();
        }
        this.loading = false;
      }, 500);
    },
    async participantDelete() {
      this.loading = "actionsButton";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.$confirm(this.$t("participantManagament.registrationSearch.detailsParticipant.deleteParticipant"), this.$t("participantManagament.registrationSearch.detailsParticipant.warning"), {
          confirmButtonText: this.$t("participantManagament.registrationSearch.detailsParticipant.deleteYes"),
          cancelButtonText: this.$t("participantManagament.registrationSearch.detailsParticipant.cancel"),
          type: "warning"
        })
          .then(async () => {
            var res = await this.$store.dispatch("deleteParticipant", this.form.id);
            this.loading = false;
            if (!res.data.alert.hasError) {
              this.$emit("deletedMe");
            }
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    async approveService(id, status) {
      this.loading = "approveService-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.form.id,
          additionalServiceId: id,
          status: status,
          cancellationReason: null
        };
        var res = await this.$store.dispatch("changeAdditionalServiceStatus", payload);
        if (!res.data.alert.hasError) {
          await this.refreshParticipant();
        }
        this.loading = false;
      }, 500);
    },
    async approveAccom(id, status) {
      this.loading = "approveAccom-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.form.id,
          accompayingPersonId: id,
          status: status,
          cancellationReason: null
        };
        var res = await this.$store.dispatch("changeAccompayingPersonStatus", payload);
        if (!res.data.alert.hasError) {
          await this.refreshParticipant();
        }
        this.loading = false;
      }, 500);
    },
    async approveSubEvent(id) {
      this.loading = "approveSubEvent-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("participantConfirmSubEvent", id);
        if (!res.data.alert.hasError) {
          await this.refreshParticipant();
        }
        this.loading = false;
      }, 500);
    },
    sendParticipantVoucher() {
      var list = [this.form.id];
      this.sendVoucher(list, null);
    },
    async uploadFile() {
      let file = this.$refs.file.files[0];
      var fd = new FormData();
      fd.append("file", file);
      var res = await axios.post("event/uploadImage?uploadType=participantProfile", fd, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        this.form.image = res.data.data.item.url;
        var res = await this.$store.dispatch("saveProfilePictureParticipant", { image: this.form.image, id: this.form.id });
        if (!res.data.alert.hasError) {
          this.form.imagePublic = res.data.data.imagePublic;
        }
      }
      this.$refs.file.value = null;
    },

    addProfilePicture() {
      this.$refs.file.click();
    },
    async setParticipantImage(image) {
      this.form.image = JSON.parse(JSON.stringify(image));
      var res = await this.$store.dispatch("saveProfilePictureParticipant", { image: image, id: this.form.id });
      if (!res.data.alert.hasError) {
        this.form.imagePublic = res.data.data.imagePublic;
      }
    },
    getQuestionOne(question) {
      var returned = this.allQuestions.find(x => x.id == question.registrationInputID);
      if (returned == null) {
        return returned;
      }
      returned.answer = question.answer;
      returned.answers = question.answers;
      returned.options = question.options;
      return returned;
    },
    async refreshActivationCode() {
      if (this.timeout != null) clearTimeout(this.timeout);

      this.loading = "refreshActivationCode";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("refreshActivationCode", this.id);
        if (!res.data.alert.hasError) {
          this.form.activation = res.data.data.activation;
          this.$message.success(this.$t("participantManagament.registrationSearch.detailsParticipant.activationCodeRefresh"));
        }
        this.loading = false;
      }, 500);
    },
    copySuccess() {
      this.$message.success(this.$t("message.refreshActivationCode"));
    },

    async refreshParticipant() {
      var res = await this.$store.dispatch("getParticipantOne", this.id);
      if (res.data.alert.hasError) {
        this.$emit("closeMe");
      } else {
        this.form = res.data.data.item;
        this.onsiteUser = res.data.data.onsiteUser;
        this.certificateSchemes = res.data.data.certificateSchemes;
        this.$store.commit("setOneParticipant", res.data.data.item);
        this.$emit("refreshList");

        var responsoQuestions = await this.$store.dispatch("getQuestionsObject", { id: this.form.registrationFormId, type: 0 });

        var resForm = await this.$store.dispatch("getRegisterFormOne", this.form.registrationFormId);
        await this.$store.dispatch("getTags");
        this.registrationForm = resForm.data.data.item;
        this.allQuestions = responsoQuestions.data.data.items;
        this.refreshKey += 1;
      }
    },
    async blockParticipant() {
      this.loading = "actionsButton";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.$confirm(this.form.isBlocked ? this.$t("participantManagament.registrationSearch.detailsParticipant.unBlockParticipant") : this.$t("participantManagament.registrationSearch.detailsParticipant.blockParticipant"), this.$t("participantManagament.registrationSearch.detailsParticipant.warning"), {
          confirmButtonText: this.$t("participantManagament.registrationSearch.detailsParticipant.blockYes"),
          cancelButtonText: this.$t("participantManagament.registrationSearch.detailsParticipant.cancel"),
          type: "warning"
        })
          .then(async () => {
            var res = await this.$store.dispatch("participantBlock", this.form.id);
            if (!res.data.alert.hasError) {
              await this.refreshParticipant();
            }
            this.loading = false;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("participantManagament.registrationSearch.detailsParticipant.blockCancel")
            });
            this.loading = false;
          });
      }, 500);
    },
    async checkIn() {
      this.loading = "actionsButton";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("checkIn", this.form.id);
        if (!res.data.alert.hasError) {
          await this.refreshParticipant();
        }
        this.loading = false;
      }, 500);
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dateNow() {
      return new Date(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).setHours(3)).toISOString();
    }
  },
  async created() {
    if (this.id != undefined && this.id != null) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.createLoading = "created";
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getTags");
        await this.refreshParticipant();
        this.createLoading = false;
      }, 500);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails.vue